import { ComponentSuspense } from "@/components/ui/suspense-wrapper";
import type { RouteConfig } from "./types";
import { lazy } from "react";

const HomePage = lazy(() => import("@/pages/app/user/home"));

// Profile page
const ProfilePage = lazy(() => import("@/pages/app/profile"));

// Billing pages
const BillingPage = lazy(() => import("@/pages/app/user/billing"));
const UpgradePage = lazy(() => import("@/pages/app/user/billing/upgrade"));
const InvoiceDetailPage = lazy(() => import("@/pages/app/user/billing/invoice/[invoiceNumber]"));
const CheckoutPage = lazy(() => import("@/pages/app/user/billing/checkout"));

// Company pages
const CompanyPage = lazy(() => import("@/pages/app/company"));

export const userRoutes: RouteConfig[] = [
  {
    path: "",
    element: (
      <ComponentSuspense>
        <HomePage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Home | Uzabox Central",
      description: "Apply for different services",
    },
  },
  {
    path: "profile",
    element: (
      <ComponentSuspense>
        <ProfilePage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Profile | UzaForm",
      description: "Manage your profile information and security settings",
    },
  },
  {
    path: "billing",
    element: (
      <ComponentSuspense>
        <BillingPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Billing | Uzabox Central",
      description: "Manage your subscription and billing",
    },
  },
  {
    path: "billing/upgrade",
    element: (
      <ComponentSuspense>
        <UpgradePage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Upgrade Subscription | Uzabox Central",
      description: "Upgrade your subscription plan",
    },
  },
  {
    path: "billing/invoice/:invoiceNumber",
    element: (
      <ComponentSuspense>
        <InvoiceDetailPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Invoice Details | Uzabox Central",
      description: "View invoice details",
    },
  },
  {
    path: "billing/checkout",
    element: (
      <ComponentSuspense>
        <CheckoutPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Checkout | Uzabox Central",
      description: "Complete your payment",
    },
  },
  {
    path: "company",
    element: (
      <ComponentSuspense>
        <CompanyPage />
      </ComponentSuspense>
    ),
    meta: {
      title: "Company | Uzabox Central",
      description: "View and manage your active company",
    },
  },
];
